export default __webpack_public_path__ + "static/media/640_business06-fr-web.e664d029.png";